<template>
  <div class="qrcodejs2">
    <!--<canvas :id="gernerateId"></canvas>-->
    <div :id="gernerateId" :ref="gernerateId"></div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  name: 'qrcodejs2',
  props: {
    code: {
      type: String,
      default() {
        return 'no2code'
      }
    },
    index: {
      type: String,
      default() {
        return 0
      }
    },
    width: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  watch: {
    width: {
      handler(val, oldVal) {
        // debugger;
        // this.qrWidth = val * 0.6;
        // console.log('aaaa')
        // if (val !== oldVal) {
        //     this.$nextTick(() => {
        //         this.getBarCode()
        //     })
        // }
      },
      immediate: true
    }
  },
  data() {
    return {
      gernerateId: '',
      qrWidth: 0
    }
  },
  created() {
    this.gernerateId = 'qrcode_' + this.index
  },
  mounted() {
    this.$nextTick(() => {
      // debugger;
      // this.qrWidth = this.width * 0.6;
      this.getQrcode()
    })
  },
  methods: {
    getQrcode() {
      new QRCode(this.$refs[this.gernerateId], {
        text: this.code + '',
        width: this.width,
        height: this.width,
        colorDark: '#333333', //二维码颜色
        colorLight: '#ffffff', //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      })
      // barcode('#' + this.gernerateId, this.code, {
      //     height: 80,
      //     width: 1.7,
      //     // margin: 5,
      //     displayValue: false
      // });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/mixin.scss';
.qrcodejs2 {
  background-color: #ffffff;
  text-align: center;
  /*margin-top: rem(10px);*/
  /*height: rem(355px);*/
  > div {
    display: flex;
    justify-content: center;
  }
}
</style>
